// Klaviyo JS snippet was previously loaded here.
// Klaviyo is now a RudderStack cloud-mode destination — no client-side script needed.

export default function DynamicBottom() {
  return null;
}

// eslint-disable-next-line no-unused-vars
export function DynamicContentBottom(_props: { klaviyoPublicKey?: string }) {
  return null;
}
